import PropTypes from 'prop-types'
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationNext,
  PaginationPrevious,
  PaginationLink,
  PaginationEllipsis
} from '@components/ui/pagination'
import { cn } from 'lib/utils'

export const AdasPagination = ({ count = 1, page = 1, onChange, className, sx, ...props }) => {
  const handleChange = (newPage) => {
    if (onChange) onChange(null, newPage)
  }

  // For large page counts, show ellipsis
  const getPageNumbers = () => {
    if (count <= 7) return Array.from({ length: count }, (_, i) => i + 1)
    const pages = []
    if (page <= 4) {
      pages.push(1, 2, 3, 4, 5, '...', count)
    } else if (page >= count - 3) {
      pages.push(1, '...', count - 4, count - 3, count - 2, count - 1, count)
    } else {
      pages.push(1, '...', page - 1, page, page + 1, '...', count)
    }
    return pages
  }

  return (
    <Pagination className={cn(className)} {...props}>
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious
            onClick={() => page > 1 && handleChange(page - 1)}
            className={cn('cursor-pointer', page === 1 && 'pointer-events-none opacity-50')}
          />
        </PaginationItem>
        {getPageNumbers().map((p, i) => (
          <PaginationItem key={i}>
            {p === '...' ? (
              <PaginationEllipsis />
            ) : (
              <PaginationLink isActive={p === page} onClick={() => handleChange(p)} className='cursor-pointer'>
                {p}
              </PaginationLink>
            )}
          </PaginationItem>
        ))}
        <PaginationItem>
          <PaginationNext
            onClick={() => page < count && handleChange(page + 1)}
            className={cn('cursor-pointer', page === count && 'pointer-events-none opacity-50')}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  )
}

AdasPagination.propTypes = {
  count: PropTypes.number,
  page: PropTypes.number,
  onChange: PropTypes.func,
  className: PropTypes.string
}
